import { render, staticRenderFns } from "./AppNaved.vue?vue&type=template&id=3756c13b&scoped=true"
import script from "./AppNaved.vue?vue&type=script&lang=js"
export * from "./AppNaved.vue?vue&type=script&lang=js"
import style0 from "./AppNaved.vue?vue&type=style&index=0&id=3756c13b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3756c13b",
  null
  
)

export default component.exports